import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrificePlate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 140,
	viewBox: "0 0 40.0 140.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 20,
			cy: 20,
			rx: 20,
			ry: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 20.0 40.0 L 20.0 140.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 20,
			cy: 20,
			rx: 4,
			ry: 4,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgOrificePlate;
